var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[(_vm.showPage === 0)?_c('customer-create-list'):(_vm.showPage === 1)?_c('div',[_c('DashboardCharts'),_c('terminal-ops',{ref:"terminalOps"})],1):(_vm.showPage === 2)?_c('order-list'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }